import React, { useEffect, useMemo, useRef, useState } from "react";
import styles from "../Detail.module.scss";
import classNames from "classnames/bind";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import { CardItem } from "./Card";

const cx = classNames.bind(styles);

export default function CardsCarousel({ title, items, period }) {
  const getVisible = () => {
    if (typeof window === 'undefined') return 3;
    const w = window.innerWidth;
    if (w <= 768) return 1;      // phone
    if (w <= 1024) return 2;     // tablet
    return 3;                    // laptop/desktop
  };
  const [visible, setVisible] = useState(getVisible);
  useEffect(() => {
    const onResize = () => setVisible(getVisible());
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const [idx, setIdx] = useState(0);
  const [expanded, setExpanded] = useState(null);
  const viewportRef = useRef(null);
  const [offset, setOffset] = useState(0);

  const maxStart = (count, vis) => Math.max(0, count - vis);
  const maxIdx = useMemo(() => maxStart(items.length, visible), [items.length, visible]);

  useEffect(() => {
    setIdx(i => Math.min(i, maxIdx));
  }, [maxIdx]);

  useEffect(() => {
    const w = (typeof window !== 'undefined') ? window.innerWidth : 1920;
    const gap = w <= 768 ? 16 : (w <= 1024 ? 20 : 32);
    const vw = viewportRef.current ? viewportRef.current.clientWidth : 0;
    // width per card based on how many are visible
    const cardWidth = visible <= 1 ? vw : ((vw - gap * (visible - 1))-24) / visible;
    const step = cardWidth + gap;
    const extra = (expanded != null && expanded < idx) ? step : 0;
    setOffset(idx * step + extra);
  }, [idx, expanded, items.length, visible]);

  return (
    <section className={cx("section", "sliderSection")}> 
      <h3 className={cx("sectionTitle")}>{title}</h3>
      <button className={cx("navBtn", "prevBtn")} disabled={idx <= 0} onClick={() => setIdx(i => Math.max(0, i - 1))}>
        <FaChevronLeft />
      </button>
      <button className={cx("navBtn", "nextBtn")} disabled={idx >= maxIdx} onClick={() => setIdx(i => Math.min(maxIdx, i + 1))}>
        <FaChevronRight />
      </button>

      <div ref={viewportRef} className={cx("viewport")}>
        <div className={cx("track")} style={{ transform: `translateX(-${offset}px)` }}>
          {items.map((item, i) => (
            <CardItem
              key={`${title}-${i}`}
              item={item}
              period={period}
              expanded={expanded === i}
              onToggle={() => setExpanded(prev => (prev === i ? null : i))}
            />
          ))}
        </div>
      </div>
    </section>
  );
}
